const WEEKDAYS = ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'];
const MONTHS = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

/** Parses a `YYYY-MM-DD` transaction date as a local calendar day. */
function parseDay(iso: string): Date | null {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

function startOfToday() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

/**
 * Human day label for list headers: "Idag", "Igår", "mån 6 okt" and, for
 * other years, "mån 6 okt 2025".
 */
export function dayLabel(iso: string): string {
  const day = parseDay(iso);
  if (!day) return iso;
  const today = startOfToday();
  const diff = Math.round((today.getTime() - day.getTime()) / 86_400_000);
  if (diff === 0) return 'Idag';
  if (diff === 1) return 'Igår';
  const base = `${WEEKDAYS[day.getDay()]} ${day.getDate()} ${MONTHS[day.getMonth()]}`;
  return day.getFullYear() === today.getFullYear() ? base : `${base} ${day.getFullYear()}`;
}

/** Compact date for dense rows: "Idag", "Igår", "6 okt" (+ year when not this year). */
export function shortDayLabel(iso: string): string {
  const day = parseDay(iso);
  if (!day) return iso;
  const today = startOfToday();
  const diff = Math.round((today.getTime() - day.getTime()) / 86_400_000);
  if (diff === 0) return 'Idag';
  if (diff === 1) return 'Igår';
  const base = `${day.getDate()} ${MONTHS[day.getMonth()]}`;
  return day.getFullYear() === today.getFullYear() ? base : `${base} ${day.getFullYear()}`;
}
